import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as AccountItemModeActions from 'web-app/react/modals-container/account-item-move/actions';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import * as Actions from './actions';

const Invoice = Record({
    title: '',
    invoiceNumber: 0,
    id: '',
    pdf: null,
    graphQLPdf: null,
    behaviors: new BehaviorsCollection(),
    date: null,
});

const InvoiceModalState = Record({
    show: false,
    isPreview: false,
    fetched: false,
    isSendingInvoice: false,
    isCancelingInvoice: false,
    showDetails: false,
    fetchingDetails: false,
    details: List(),
    data: Invoice(),
    billPayer: null,
    billPayerId: '',
    institutionId: '',
});

const getInvoiceFromModel = invoiceModel => {
    return new Invoice({
        title: invoiceModel.title,
        invoiceNumber: invoiceModel.invoiceNo,
        id: invoiceModel.id,
        pdf: invoiceModel.pdf,
        graphQLPdf: invoiceModel.graphQLPdf,
        behaviors: invoiceModel.behaviors,
        date: invoiceModel.date || invoiceModel.invoiceDate,
    });
};

export default handleActions(
    {
        [Actions.show.type]: (state, {payload}) => {
            return InvoiceModalState({
                show: true,
                fetched: false,
                data: new Invoice({
                    id: payload.invoiceId,
                }),
            });
        },
        [Actions.showPreview.type]: (state, {payload}) => {
            return InvoiceModalState({
                show: true,
                isPreview: true,
                fetched: !payload.useGraphQl,
                institutionId: payload.institutionId,
                billPayerId: payload.billPayerId,
                data: new Invoice({
                    title: payload.title,
                    invoiceNumber: payload.invoiceNumber,
                    id: payload.invoiceId,
                    pdf: payload.pdf,
                    behaviors: payload.invoiceBehaviors,
                }),
            });
        },
        [Actions.fetchSingleSuccess.type]: (state, {payload}) => {
            const invoice = payload.invoice;
            return state.merge({
                fetched: true,
                institutionId: invoice.institutionId,
                billPayerId: invoice.billPayerId,
                billPayer: invoice.payer,
                data: getInvoiceFromModel(invoice),
            });
        },
        [Actions.fetchGraphQLPreviewSuccess.type]: (state, {payload}) => {
            const invoice = payload.invoice;
            return state.merge({
                fetched: true,
                data: getInvoiceFromModel(invoice),
                details: invoice.details,
            });
        },

        [Actions.hide.type]: () => InvoiceModalState(),

        [Actions.showDetails.type]: (state, {payload}) =>
            state.merge({
                showDetails: payload.show,
                fetchingDetails: !payload.hasDetails,
            }),

        [Actions.showDetailsSuccess.type]: (state, {payload}) =>
            state.merge({
                fetchingDetails: false,
                details: payload.children,
            }),

        [Actions.showDetailsFailed.type]: state =>
            state.merge({
                fetchingDetails: false,
            }),
        [Actions.resend.type]: state => state.merge({isSendingInvoice: true}),
        [Actions.resendSuccess.type]: () => new InvoiceModalState(),
        [Actions.resendFailed.type]: state => state.merge({isSendingInvoice: false}),
        [Actions.resendAborted.type]: state => state.merge({isSendingInvoice: false}),

        [Actions.cancel.type]: state => state.merge({isCancelingInvoice: true}),
        [Actions.cancelSuccess.type]: () => new InvoiceModalState(),
        [Actions.cancelFailed.type]: state => state.merge({isCancelingInvoice: false}),
        [Actions.cancelAborted.type]: state => state.merge({isCancelingInvoice: false}),

        [AccountItemModeActions.moveInvoiceSuccess.type]: () => InvoiceModalState(),
        [AccountItemModeActions.movePaymentSuccess.type]: () => InvoiceModalState(),
    },
    InvoiceModalState(),
);
